// Demo evaluation, radar, calibration, bias, notifications data
import { demoData } from './data';
import { EVAL_GRADES, genRadar } from './demoEmployees';

export const demoEvaluationsService = {
  // ========== Evaluation Periods ==========
  getEvaluationPeriods: async () => ({
    periods: [
      { id: 1, name: '2025년 하반기 정기평가', status: 'completed', start_date: '2025-07-01', end_date: '2025-12-31', created_at: '2025-06-15' },
      { id: 2, name: '2026년 상반기 정기평가', status: 'active', start_date: '2026-01-01', end_date: '2026-06-30', created_at: '2025-12-20' },
    ],
    total: 2,
  }),
  createEvaluationPeriod: async () => ({ id: 3, name: 'Demo', status: 'draft' }),
  getEvaluationPeriod: async (id: number) => ({
    id, name: id === 2 ? '2026년 상반기 정기평가' : '2025년 하반기 정기평가',
    status: id === 2 ? 'active' : 'completed', start_date: id === 2 ? '2026-01-01' : '2025-07-01', end_date: id === 2 ? '2026-06-30' : '2025-12-31',
  }),
  updateEvaluationPeriod: async () => ({ success: true, message: 'Demo mode' }),
  updateEvaluationPeriodStatus: async () => ({ success: true, message: 'Demo mode' }),

  // ========== Evaluation Criteria (6-axis 18-item) ==========
  getEvaluationCriteria: async () => ({
    criteria: [
      { id: 1, code: 'TECH_001', name: '핵심 기술력', axis: 'technology', weight: 10, description: '담당 분야의 전문 기술 역량과 깊이', max_score: 5, sort_order: 1, is_manager_only: false, is_active: true },
      { id: 2, code: 'TECH_002', name: '기술 설계 능력', axis: 'technology', weight: 8, description: '아키텍처/설계 관점의 기술적 의사결정 역량', max_score: 5, sort_order: 2, is_manager_only: false, is_active: true },
      { id: 3, code: 'TECH_003', name: '기술 혁신', axis: 'technology', weight: 7, description: '새로운 기술 도입, R&D 기여', max_score: 5, sort_order: 3, is_manager_only: false, is_active: true },
      { id: 4, code: 'PROD_001', name: '제품 완성도', axis: 'product', weight: 10, description: '담당 제품/서비스의 품질과 완성도 기여', max_score: 5, sort_order: 4, is_manager_only: false, is_active: true },
      { id: 5, code: 'PROD_002', name: '사용자 관점', axis: 'product', weight: 8, description: 'UX/고객 경험 개선에 대한 이해와 기여', max_score: 5, sort_order: 5, is_manager_only: false, is_active: true },
      { id: 6, code: 'PROD_003', name: '로드맵 기여', axis: 'product', weight: 7, description: '제품 로드맵 수립 및 PMF 달성 기여도', max_score: 5, sort_order: 6, is_manager_only: false, is_active: true },
      { id: 7, code: 'EXEC_001', name: '목표 달성률', axis: 'execution', weight: 12, description: '설정된 목표(KPI/OKR) 대비 실제 달성 수준', max_score: 5, sort_order: 7, is_manager_only: false, is_active: true },
      { id: 8, code: 'EXEC_002', name: '실행 속도', axis: 'execution', weight: 8, description: '기획→실행→완료까지의 속도와 추진력', max_score: 5, sort_order: 8, is_manager_only: false, is_active: true },
      { id: 9, code: 'EXEC_003', name: '의사결정력', axis: 'execution', weight: 8, description: '적시에 합리적 판단을 내리고 실행하는 능력', max_score: 5, sort_order: 9, is_manager_only: false, is_active: true },
      { id: 10, code: 'PEOP_001', name: '협업·소통', axis: 'people', weight: 8, description: '팀원 및 유관부서와의 효과적인 소통과 협업', max_score: 5, sort_order: 10, is_manager_only: false, is_active: true },
      { id: 11, code: 'PEOP_002', name: '리더십·육성', axis: 'people', weight: 8, description: '팀 관리, 후배 육성, 코칭 역량', max_score: 5, sort_order: 11, is_manager_only: true, is_active: true },
      { id: 12, code: 'PEOP_003', name: '조직 문화 기여', axis: 'people', weight: 7, description: '긍정적 조직 문화 형성 및 인재상 실천', max_score: 5, sort_order: 12, is_manager_only: false, is_active: true },
      { id: 13, code: 'BUSI_001', name: '사업 이해도', axis: 'business', weight: 8, description: '회사 비즈니스 모델과 시장에 대한 이해', max_score: 5, sort_order: 13, is_manager_only: false, is_active: true },
      { id: 14, code: 'BUSI_002', name: '고객·파트너 관리', axis: 'business', weight: 7, description: '고객 확보/유지, 파트너십 구축 기여', max_score: 5, sort_order: 14, is_manager_only: false, is_active: true },
      { id: 15, code: 'BUSI_003', name: '수익 기여', axis: 'business', weight: 7, description: '매출/수익 창출에 대한 직·간접 기여도', max_score: 5, sort_order: 15, is_manager_only: false, is_active: true },
      { id: 16, code: 'SCAL_001', name: '변화 적응력', axis: 'scalability', weight: 8, description: '시장·조직 변화에 유연하게 대응하는 능력', max_score: 5, sort_order: 16, is_manager_only: false, is_active: true },
      { id: 17, code: 'SCAL_002', name: '확장성 사고', axis: 'scalability', weight: 7, description: '시스템·프로세스의 확장 가능한 설계 기여', max_score: 5, sort_order: 17, is_manager_only: false, is_active: true },
      { id: 18, code: 'SCAL_003', name: '학습·성장', axis: 'scalability', weight: 7, description: '자기개발 노력, 새로운 역량 습득 의지와 성과', max_score: 5, sort_order: 18, is_manager_only: false, is_active: true },
    ],
    total: 18,
  }),
  createEvaluationCriterion: async () => ({ success: true, message: 'Demo mode' }),
  updateEvaluationCriterion: async () => ({ success: true, message: 'Demo mode' }),
  deleteEvaluationCriterion: async () => ({ success: true, message: 'Demo mode' }),

  // ========== Evaluation Assignments ==========
  getEvaluationAssignments: async (_periodId?: number) => {
    const teamLeaders: Record<string, { id: string; name: string }> = {
      '경영지원팀': { id: 'TS2600001', name: '김도현' }, '영업팀': { id: 'TS2600004', name: '최민지' },
      '연구개발팀': { id: 'TS2600009', name: '임태현' }, '품질관리팀': { id: 'TS2600015', name: '서동훈' },
      '생산팀': { id: 'TS2600019', name: '장민수' }, 'IT개발팀': { id: 'TS2600024', name: '하은서' },
    };
    const emps = demoData.employees?.employees || [];
    return {
      assignments: emps.map((e: any, i: number) => {
        const g = EVAL_GRADES[e.employee_id] || { grade: 'B', score: 35, status: 'pending' };
        const leader = teamLeaders[e.team] || teamLeaders['경영지원팀'];
        return {
          id: i + 1, period_id: 2, evaluatee_id: e.employee_id, evaluatee_name: e.name, evaluatee_team: e.team,
          evaluator_id: leader.id, evaluator_name: leader.name, evaluator_type: 'supervisor',
          status: g.status, total_score: g.status === 'completed' ? g.score : null, created_at: '2026-01-15',
        };
      }),
      total: emps.length,
    };
  },
  submitEvaluationScores: async () => ({ success: true, message: 'Scores submitted (demo)' }),
  getEvaluationScores: async () => [
    { id: 1, criteria_id: 1, code: 'COMP01', axis: 'competency', name: '기술 역량', score: 4.5, max_score: 5, weight: 20, comment: '핵심 기술 능숙' },
    { id: 2, criteria_id: 2, code: 'COMP02', axis: 'competency', name: '문제 해결력', score: 4.0, max_score: 5, weight: 15, comment: '복잡한 이슈 자주 해결' },
    { id: 3, criteria_id: 3, code: 'COMP03', axis: 'competency', name: '의사소통', score: 3.5, max_score: 5, weight: 15, comment: '팀 내 협업 양호' },
    { id: 4, criteria_id: 4, code: 'PERF01', axis: 'performance', name: 'KPI 달성률', score: 4.0, max_score: 5, weight: 25, comment: '목표 대비 95% 달성' },
    { id: 5, criteria_id: 5, code: 'PERF02', axis: 'performance', name: '업무 품질', score: 4.5, max_score: 5, weight: 15, comment: '높은 품질 유지' },
    { id: 6, criteria_id: 6, code: 'LEAD01', axis: 'leadership', name: '리더십', score: 3.0, max_score: 5, weight: 10, comment: '성장 중' },
  ],
  autoAssignEvaluators: async (_periodId?: number, _force?: boolean) => ({ success: true, message: '29명에 대해 자동 배정 완료 (demo)' }),
  saveScoresDraft: async () => ({ success: true, message: 'Draft saved (demo)' }),
  finalizeScores: async () => ({ success: true, message: 'Finalized (demo)' }),
  reopenAssignment: async () => ({ success: true, message: 'Reopened (demo)' }),
  getScoreProgress: async (_periodId?: number) => {
    const completed = Object.values(EVAL_GRADES).filter(g => g.status === 'completed').length;
    return { scored: completed, total: 29, progress_pct: Math.round(completed / 29 * 100) };
  },
  getMyAssignments: async (_periodId?: number) => {
    const teamMembers = demoData.employees?.employees?.filter((e: any) => e.team === '경영지원팀' && e.employee_id !== 'TS2600001') || [];
    return {
      employee_id: 'TS2600001',
      as_evaluator: teamMembers.map((e: any, i: number) => {
        const g = EVAL_GRADES[e.employee_id] || { grade: 'B', score: 35, status: 'pending' };
        return {
          id: i + 1, period_id: 2, evaluatee_id: e.employee_id, evaluatee_name: e.name, evaluatee_team: e.team,
          status: g.status, total_score: g.status === 'completed' ? g.score : null,
        };
      }),
      as_evaluatee: [{ id: 100, period_id: 2, evaluator_id: 'TS2600009', evaluator_name: '임태현', evaluator_type: 'supervisor', status: 'completed', total_score: 47 }],
      total_as_evaluator: teamMembers.length,
      total_as_evaluatee: 1,
    };
  },
  getPeriodProgress: async (_periodId?: number) => {
    const completed = Object.values(EVAL_GRADES).filter(g => g.status === 'completed').length;
    return {
      period_id: 2, overall_progress_pct: Math.round(completed / 29 * 100), total_assignments: 29, total_completed: completed,
      stages: [
        { stage: '평가 배정', completed: 29, total: 29, pct: 100 },
        { stage: '점수 입력', completed, total: 29, pct: Math.round(completed / 29 * 100) },
        { stage: '등급 산정', completed: Math.round(completed * 0.8), total: 29, pct: Math.round(completed * 0.8 / 29 * 100) },
        { stage: '면담 완료', completed: Math.round(completed * 0.3), total: 29, pct: Math.round(completed * 0.3 / 29 * 100) },
      ],
    };
  },

  // ========== Evaluation Results ==========
  getEvaluationResults: async (_periodId?: number) => {
    const emps = demoData.employees?.employees || [];
    return {
      results: emps.map((e: any, i: number) => {
        const g = EVAL_GRADES[e.employee_id] || { grade: 'B', score: 35, status: 'pending' };
        return {
          id: i + 1, period_id: 2, employee_id: e.employee_id, employee_name: e.name, team: e.team,
          total_score: g.score, grade: g.grade,
          status: g.status === 'completed' ? 'finalized' : g.status, created_at: '2026-02-01',
        };
      }),
      total: emps.length,
    };
  },
  getEvaluationResult: async () => null,
  getEmployeeEvaluationResults: async (id: string) => {
    const g = EVAL_GRADES[id] || { grade: 'B', score: 35, status: 'pending' };
    return [{
      id: 1, period_id: 2, employee_id: id,
      axis_scores: {
        technology: +(g.score / 12 + Math.random() * 0.5).toFixed(1),
        product: +(g.score / 13 + Math.random() * 0.5).toFixed(1),
        execution: +(g.score / 12 + Math.random() * 0.5).toFixed(1),
        people: +(g.score / 14 + Math.random() * 0.3).toFixed(1),
        business: +(g.score / 15 + Math.random() * 0.4).toFixed(1),
        scalability: +(g.score / 14 + Math.random() * 0.5).toFixed(1),
      },
      total_score: g.score, grade: g.grade,
      is_manager: false, final_comment: '',
      confirmed_by: null,
      confirmed_at: g.status === 'completed' ? '2026-02-01' : null,
    }];
  },
  calculatePeriodGrades: async () => ({ success: true, message: 'Grades calculated (demo)' }),

  // ========== Evaluation Interviews ==========
  getEvaluationInterviews: async () => [
    { id: 1, evaluatee_id: 'TS2600001', evaluatee_name: '오명석', evaluator_id: 'TS2600002', evaluator_name: '김선영', period_id: 1, status: 'completed', scheduled_date: '2026-01-20', completed_date: '2026-01-20', notes: '상반기 목표 달성 면담', score_agreed: true },
    { id: 2, evaluatee_id: 'TS2600005', evaluatee_name: '정승민', evaluator_id: 'TS2600002', evaluator_name: '김선영', period_id: 1, status: 'scheduled', scheduled_date: '2026-02-15', completed_date: null, notes: null },
    { id: 3, evaluatee_id: 'TS2600010', evaluatee_name: '한지원', evaluator_id: 'TS2600004', evaluator_name: '박민호', period_id: 1, status: 'completed', scheduled_date: '2026-01-18', completed_date: '2026-01-18', notes: '역량 강화 계획 수립', score_agreed: true },
  ],
  createEvaluationInterview: async () => ({ id: 0, status: 'scheduled' }),
  scheduleInterview: async () => ({ message: 'Demo mode', id: 0, result_id: 0, status: 'scheduled' }),
  completeInterview: async () => ({ message: 'Demo mode', id: 0, status: 'completed' }),
  signInterview: async () => ({ message: 'Demo mode', id: 0, status: 'signed' }),
  getEmployeeInterviews: async (employeeId: string) => ({ employee_id: employeeId, interviews: [], total: 0 }),
  getEmployeePersonnelTimeline: async (employeeId: string) => ({ success: true, data: { employee_id: employeeId, timeline: [], total: 0, categories: {} } }),
  getInterviewStats: async (_periodId?: number) => ({
    total_employees: 29, interviews_scheduled: 12, interviews_completed: 5, interviews_signed: 3,
    not_scheduled: demoData.employees?.employees?.slice(12).map((e: any) => ({ employee_id: e.employee_id, employee_name: e.name, team: e.team })) || [],
    completion_rate: 17.2,
  }),
  getPendingInterviews: async (_periodId?: number, _interviewerId?: string) => ({
    interviews: demoData.employees?.employees?.slice(5, 12).map((e: any, i: number) => ({
      id: i + 1, result_id: i + 6, employee_id: e.employee_id, employee_name: e.name, team: e.team,
      status: i < 4 ? 'scheduled' : 'completed', scheduled_date: '2026-02-15',
    })) || [],
    total: 7,
  }),
  getInterviewEligible: async (_periodId: number) => ({
    employees: demoData.employees?.employees?.slice(0, 5).map((e: any, i: number) => ({
      result_id: i + 1, employee_id: e.employee_id, employee_name: e.name,
      team: e.team, position: e.position, total_score: 70 + i * 5, grade: ['S', 'A', 'A', 'B', 'B'][i],
    })) || [],
    total: 5,
  }),

  // ========== Evaluation Appeals ==========
  getEvaluationAppeals: async (_periodId?: number) => ({
    appeals: [
      { id: 1, period_id: 2, employee_id: 'TS2600013', employee_name: '조현우', team: '연구개발팀', original_grade: 'C', requested_grade: 'B', reason: '프로젝트 기여도가 반영되지 않았습니다.', status: 'submitted', created_at: '2026-02-03', appeal_deadline: '2026-02-17' },
      { id: 2, period_id: 2, employee_id: 'TS2600022', employee_name: '안미래', team: '생산팀', original_grade: 'D', requested_grade: 'C', reason: '생산라인 개선 기여가 누락되었습니다.', status: 'under_review', reviewer_id: 'TS2600019', created_at: '2026-02-01', appeal_deadline: '2026-02-15' },
    ],
    total: 2,
  }),
  createEvaluationAppeal: async () => ({ id: 0, status: 'submitted' }),
  reviewEvaluationAppeal: async () => ({ success: true, message: 'Reviewed (demo)' }),
  createAppealWithEvidence: async () => ({ success: true, message: 'Appeal created (demo)' }),
  assignAppealReviewer: async () => ({ success: true, message: 'Reviewer assigned (demo)' }),

  // ========== Notifications ==========
  getEvaluationNotifications: async () => [
    { id: 1, type: 'result', employee_id: 'TS2600001', employee_name: '오명석', period_id: 1, message: '2025년 하반기 평가 결과가 통지되었습니다', acknowledged: false, created_at: '2026-02-01' },
    { id: 2, type: 'appeal_deadline', employee_id: 'TS2600003', employee_name: '이지영', period_id: 1, message: '이의제기 마감 3일 전입니다', acknowledged: true, created_at: '2026-01-28' },
  ],
  acknowledgeEvaluationNotification: async () => ({ success: true, message: 'Demo mode' }),
  getNotificationCompliance: async (_periodId?: number) => ({
    period_id: 2, total_employees: 29, notified: 22, acknowledged: 18, overdue: 3, compliance_rate: 75.9, deadline_days: 14, details: [],
  }),
  getNotificationSummary: async () => ({ total: 29, sent: 22, acknowledged: 18 }),
  sendBulkNotifications: async () => ({ success: true, message: 'Bulk notifications sent (demo)' }),

  // ========== Appeal Deadlines & Bias ==========
  getAppealDeadlines: async (_periodId?: number) => ({
    period_id: 2, total_appeals: 2, within_deadline: 2, overdue_submit: 0, overdue_review: 0, details: [],
  }),
  getBiasAnalysis: async (_periodId?: number) => ({
    period_id: 2, total_evaluated: 29,
    gender_distribution: { male: { count: 16, avg_score: 37.8 }, female: { count: 13, avg_score: 38.2 } },
    age_distribution: { '24-30': { count: 10, avg_score: 32.4 }, '31-40': { count: 11, avg_score: 38.9 }, '41+': { count: 8, avg_score: 44.6 } },
    warnings: ['연령대별 점수 편차가 12.2점으로 모니터링 권장 (경력 연수와 상관관계 확인 필요)'],
  }),

  // ========== Evaluation Summary ==========
  getEvaluationSummary: async (_periodId?: number) => {
    const completed = Object.values(EVAL_GRADES).filter(g => g.status === 'completed').length;
    return { period_id: 2, total: 29, completed, completion_rate: Math.round(completed / 29 * 1000) / 10 };
  },

  // ========== Radar Charts ==========
  getEvaluationRadar: async (employeeId?: string, _periodId?: number) => {
    const eid = employeeId || 'TS2600001';
    const emp: any = demoData.employees?.employees?.find((e: any) => e.employee_id === eid || e.id === eid);
    const team = emp?.team || '경영지원팀';
    return { employee_id: eid, axes: genRadar(eid, team) };
  },
  getHrRadar: async () => ({ entity_id: 'company', period_id: 2, perspective: 'hr' as const, axes: [
    { name: '기술 경쟁력', axis: 'technology', value: 3.9, max_value: 5 },
    { name: '제품/서비스 역량', axis: 'product', value: 3.6, max_value: 5 },
    { name: '실행력', axis: 'execution', value: 4.0, max_value: 5 },
    { name: '조직·인재 역량', axis: 'people', value: 3.5, max_value: 5 },
    { name: '비즈니스 역량', axis: 'business', value: 3.2, max_value: 5 },
    { name: '확장·변화 대응력', axis: 'scalability', value: 3.8, max_value: 5 },
  ]}),
  getOrgRadar: async () => ({ entity_id: 'org', period_id: 2, perspective: 'org' as const, axes: [
    { name: '기술 경쟁력', axis: 'technology', value: 4.0, max_value: 5 },
    { name: '제품/서비스 역량', axis: 'product', value: 3.7, max_value: 5 },
    { name: '실행력', axis: 'execution', value: 3.9, max_value: 5 },
    { name: '조직·인재 역량', axis: 'people', value: 3.6, max_value: 5 },
    { name: '비즈니스 역량', axis: 'business', value: 3.4, max_value: 5 },
    { name: '확장·변화 대응력', axis: 'scalability', value: 3.7, max_value: 5 },
  ]}),
  getLeaderRadar: async () => ({ entity_id: 'leader', period_id: 2, perspective: 'leader' as const, axes: [
    { name: '기술 경쟁력', axis: 'technology', value: 4.1, max_value: 5 },
    { name: '제품/서비스 역량', axis: 'product', value: 4.3, max_value: 5 },
    { name: '실행력', axis: 'execution', value: 4.2, max_value: 5 },
    { name: '조직·인재 역량', axis: 'people', value: 4.4, max_value: 5 },
    { name: '비즈니스 역량', axis: 'business', value: 3.8, max_value: 5 },
    { name: '확장·변화 대응력', axis: 'scalability', value: 4.0, max_value: 5 },
  ]}),

  // ========== Company Values ==========
  getCompanyValues: async () => ({
    values: [
      { id: 1, keyword: 'Positive', description: '즐겁게 일하며 팀에 좋은 에너지를 만드는 사람', sort_order: 1, is_active: true },
      { id: 2, keyword: 'Action-Oriented', description: '완벽을 기다리기보다 일단 실행하는 사람', sort_order: 2, is_active: true },
      { id: 3, keyword: 'Critical Thinker', description: "'왜?'를 묻고 본질을 고민하는 사람", sort_order: 3, is_active: true },
      { id: 4, keyword: 'Continuous Improver', description: '현재 방식에 안주하지 않고 계속 바꾸는 사람', sort_order: 4, is_active: true },
    ],
    total: 4,
  }),
  createCompanyValue: async () => ({ success: true, message: 'Demo mode' }),
  updateCompanyValue: async () => ({ success: true, message: 'Demo mode' }),
  deleteCompanyValue: async () => ({ success: true, message: 'Demo mode' }),

  // ========== Calibration ==========
  getDistributionSuggestions: async (_periodId?: number) => ({
    valid: false, total: 10, violations: ['B등급이 기준(40%) 대비 초과'],
    suggestions: [
      { employee_id: 'TS2600013', employee_name: '조현우', current_grade: 'B', suggested_grade: 'C', reason: '강제 배분 기준 초과' },
    ],
  }),
  applyCalibration: async () => ({ id: 1, result_id: 1, original_grade: 'B', adjusted_grade: 'C', reason: '강제 배분', calibrated_by: 'admin', calibrated_at: Date.now() }),
  getCalibrationHistory: async (_periodId?: number) => [
    { id: 1, result_id: 4, employee_name: '최민지', original_grade: 'A', adjusted_grade: 'B', reason: '강제 배분 조정', calibrated_by: 'admin', calibrated_at: '2026-02-05' },
  ],
  revertCalibration: async () => ({ success: true, message: 'Reverted (demo)' }),

  // ========== Grade Distribution & Calibration Sessions ==========
  getGradeDistribution: async (_periodId: number) => ({ distribution: [
    { grade: 'S', count: 3, ratio: 10, avg_score: 95 },
    { grade: 'A', count: 6, ratio: 20, avg_score: 85 },
    { grade: 'B', count: 12, ratio: 40, avg_score: 75 },
    { grade: 'C', count: 6, ratio: 20, avg_score: 65 },
    { grade: 'D', count: 3, ratio: 10, avg_score: 55 },
  ], total: 30, standard: { S: 10, A: 20, B: 40, C: 20, D: 10 } }),
  createCalibrationSession: async (_data: any) => ({ id: 1 }),
  getCalibrationSessions: async () => [
    { id: 1, period_id: 1, name: '2025 하반기 등급 보정', status: 'completed', conducted_by: '박승우', conducted_at: '2026-01-25', adjustments_count: 3 },
  ],
  getCalibrationSession: async (id: number) => ({ id, adjustments: [] }),
  saveCalibrationAdjustments: async (_sessionId: number, _adjs: any[]) => ({ saved: 0 }),
  applyCalibrationSession: async (_sessionId: number) => ({ applied: 0 }),
  getCalibrationComparison: async (_periodId: number) => ({ companies: [], standard_distribution: { S: 10, A: 20, B: 40, C: 20, D: 10 } }),

  // ========== Eval Policies (BACK-118) ==========
  getEvalPolicies: async () => ({ policies: [
    { id: 1, company_id: 1, company_name: '티사이언티픽', policy_name: '티사이언티픽 표준 평가 정책', evaluation_type: 'relative', group_common_weight: 0.6, company_custom_weight: 0.4, allow_cross_eval: 0, is_active: 1, grade_distribution: { S: 10, A: 20, B: 40, C: 20, D: 10 } },
  ], total: 1 }),
  getEvalPolicySummary: async () => ({ summary: [
    { id: 1, company_id: 1, company_name: '티사이언티픽', company_code: 'TSCORP', policy_name: '표준 평가', evaluation_type: 'relative', group_common_weight: 0.6, company_custom_weight: 0.4, group_criteria_count: 5, company_criteria_count: 3, total_weight: 100 },
  ] }),
  getEvalPolicy: async () => ({ id: 1, company_id: 1, policy_name: '티사이언티픽 표준 평가 정책', evaluation_type: 'relative', group_common_weight: 0.6, company_custom_weight: 0.4, grade_distribution: { S: 10, A: 20, B: 40, C: 20, D: 10 }, criteria: [] }),
  createEvalPolicy: async (data: any) => ({ id: 2, ...data }),
  updateEvalPolicy: async (_id: number, data: any) => data,
  deleteEvalPolicy: async () => ({ message: '정책이 비활성화되었습니다' }),
  getEvalCriteria: async () => ({ criteria: [], total: 0 }),
  addEvalCriteria: async (pid: number, data: any) => ({ id: 1, policy_id: pid, ...data }),
  updateEvalCriteria: async (_id: number, data: any) => data,
  deleteEvalCriteria: async () => ({ message: '항목이 비활성화되었습니다' }),
  compareEvalPolicies: async () => ({ policies: [], total: 0 }),

  // ========== Group Eval Reports/Benchmarking (BACK-120) ==========
  getGroupEvalSummary: async () => ({ company_stats: [
    { company_id: 1, company_name: '티사이언티픽', total_assigned: 37, completed: 30, pending: 5, in_progress: 2 },
  ], grade_distribution: [], avg_scores: [
    { company_id: 1, company_name: '티사이언티픽', avg_score: 78.5, min_score: 55, max_score: 95, result_count: 30 },
  ], periods: [] }),
  getGroupEvalBenchmark: async () => ({ axis_scores: [], rank_scores: [], headcount: [
    { company_id: 1, company_name: '티사이언티픽', company_code: 'TSCORP', headcount: 37, avg_tenure_years: 3.2 },
  ] }),
  getGroupTurnoverRisk: async () => ({ turnover_risk: [] }),

  // ========== Competency Framework ==========
  getCompetencyDefinitions: async () => ({ definitions: [], axis_labels: {} }),
  getCompetencyRequirements: async () => ({ base_matrix: [], job_category_overrides: {}, axis_labels: {}, rank_names: {} }),
  getCompetencyGap: async () => ({ employee: {}, evaluation: null, gaps: [], summary: { total_gap_score: 0, critical_gap_count: 0, strength_count: 0, weakness_count: 0 }, strengths: [], weaknesses: [] }),
  getCompetencyTeamGap: async () => ({ employee_count: 0, evaluated_count: 0, gaps: [] }),
  getCompetencyHeatmap: async () => ({ teams: [], axis_labels: {} }),
  getCompetencyAIRecommendation: async () => ({ ai_analysis: null, gap_summary: {} }),
  updateCompetencyRequirement: async () => ({ success: true }),

  // ========== Weight Profiles & Job Categories ==========
  getWeightProfiles: async () => ({
    role_profiles: {
      executive: { technology: 0.25, product: 0.15, execution: 0.15, people: 0.15, business: 0.20, scalability: 0.10 },
      org_head: { technology: 0.20, product: 0.15, execution: 0.20, people: 0.20, business: 0.15, scalability: 0.10 },
      employee: { technology: 0.25, product: 0.20, execution: 0.20, people: 0.10, business: 0.10, scalability: 0.15 },
    },
    job_category_profiles: {
      engineering: { technology: 0.30, product: 0.20, execution: 0.20, people: 0.10, business: 0.05, scalability: 0.15 },
      sales: { technology: 0.10, product: 0.15, execution: 0.20, people: 0.15, business: 0.30, scalability: 0.10 },
      planning: { technology: 0.10, product: 0.25, execution: 0.25, people: 0.15, business: 0.15, scalability: 0.10 },
      support: { technology: 0.10, product: 0.10, execution: 0.30, people: 0.20, business: 0.15, scalability: 0.15 },
      design: { technology: 0.15, product: 0.30, execution: 0.20, people: 0.10, business: 0.10, scalability: 0.15 },
    },
    axis_labels: {
      technology: '기술 경쟁력', product: '제품·서비스 역량', execution: '실행력',
      people: '조직·인재 역량', business: '비즈니스 역량', scalability: '확장·변화 대응력',
    },
    job_categories: [
      { code: 'engineering', name: '기술직' }, { code: 'sales', name: '영업직' },
      { code: 'planning', name: '기획직' }, { code: 'support', name: '경영지원직' },
      { code: 'design', name: '디자인직' },
    ],
  }),
};
